// extracted by mini-css-extract-plugin
export default {"rtc-tile-text":"Prop__rtc-tile-text__mbi_m","rtcTileText":"Prop__rtc-tile-text__mbi_m","rtc-value-text":"Prop__rtc-value-text__ZiJ0n","rtcValueText":"Prop__rtc-value-text__ZiJ0n"};